import { useEffect, useState } from "react";

export const useMediaQuery = (query: string) => {
  const mediaMatch = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    mediaMatch.addEventListener("change", handler);
    return () => mediaMatch.removeEventListener("change", handler);
  }, [query]);

  return !!matches;
};

export const useHasCursor = () => {
  return useMediaQuery("(hover: hover) and (pointer: fine)");
};

export const useBrowserPrefersDarkMode = () => {
  return useMediaQuery("(prefers-color-scheme: dark)");
};
